import Head from "next/head";
import Navbar from "../../components/general/Navbar";
import Header from "../../components/general/Header";
import HiddenMenu from "../../components/general/HiddenMenu";
import Footer from "../../components/general/Footer";
import RegisterForm from "../../components/form/RegisterForm";
import { useState, useEffect } from "react";
import AuthServices from "../../services/Auth.services";

export default function Index({navigation, loggedIn, jwtToken }) {
  // User
  const [auth, setAuth] = useState(loggedIn);
  const [userInfo, setUserInfo] = useState();
  useEffect(() => {
    if (!jwtToken) {
      return;
    }
    setUserInfo(AuthServices.getUserData(jwtToken));
  }, []);
  return (
    <div className="min-h-screen flex flex-col">
      <Head>
        <title>Olaf Nijenkamp | Aanmelden</title>
        <meta name="description" content="Generated by create next app" />
      </Head>

      <header>
        <Navbar items={navigation} />
        <HiddenMenu loggedIn={loggedIn} role={userInfo?.role} />
        <Header title="Aanmelden" small={true} />
      </header>

      <main className="mb-auto">
        <section className="mt-16">
          <div className="olafGrid space-y-4 lg:max-w-lg">
            <RegisterForm />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export async function getServerSideProps(context) {
  var loggedIn = context.req.cookies["auth"] ? true : false;
  if (!loggedIn) {
    return {
      props: {
        loggedIn: false,
        jwtToken: null,
      },
    };
  }
  if (loggedIn) {
    return {
      redirect: {
        destination: "/dashboard",
        permanent: false,
      },
    };
  }
  const jwtToken = context.req.cookies["auth"];

  AuthServices.cookieCheck(jwtToken, context);
  await AuthServices.refreshToken(jwtToken, context);

  return {
    props: {
      loggedIn: loggedIn,
      jwtToken: jwtToken || null,
    }, // will be passed to the page component as props
  };
}
